module.exports = __webpack_public_path__ + "static/media/middleware.7cd4e312.jpeg";